import {Avatar, Box, Card, Typography} from '@material-ui/core';
import React from 'react';
import moment from 'moment';

export function TextMessage(props: {
  myProfileImage?: string;
  farmerProfileImage?: string;
  isSent: boolean;
  date: Date;
  messageText: string;
  isImage?: boolean;
}) {
  const {
    myProfileImage,
    farmerProfileImage,
    isSent,
    date,
    messageText,
    isImage,
  } = props;
  const isReceived = !isSent;
  return (
    <Box
      className={
        isSent ? 'sent-message-container-2' : 'received-message-container-2'
      }
    >
      {isReceived && (
        <Box mr={2}>
          <Avatar src={farmerProfileImage} className={'avatar'} />
        </Box>
      )}
      <Box>
        <Card
          className={isSent ? 'sent-message' : 'received-message'}
          variant="outlined"
        >
          {isImage ? (
            <img src={messageText} alt="" className="message-image" />
          ) : (
            <Typography variant="body2">{messageText}</Typography>
          )}
        </Card>
        <Box
          className="caption-container"
          justifyContent={isSent ? 'flex-end' : null}
        >
          <Typography variant="caption" color="textSecondary">
            {moment(date).calendar()}
          </Typography>
        </Box>
      </Box>
      {isSent && (
        <Box ml={2}>
          <Avatar src={myProfileImage} className={'avatar'} />
        </Box>
      )}
    </Box>
  );
}
